import { render, staticRenderFns } from "./CoozzyReactivateIcon.vue?vue&type=template&id=61c18262&scoped=true"
import script from "./CoozzyReactivateIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyReactivateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c18262",
  null
  
)

export default component.exports